import { SortDirection } from '@warebee/frontend/data-access-api-graphql';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue } from 'recoil';
import { HeatmapBucket } from '../../common/heatmap.helper';
import useFormatter from '../../common/useFormatter';
import useActualityMetricDescriptors from '../../metrics/actuality/useActualityMetricDescriptors';
import HeatmapLegendPanel from '../../metrics/HeatmapLegendPanel';
import useShowFilteredActualityHqTable from '../hqTable/useShowFilteredActualityHqTable';
import {
  actualityHeatmapBuckets,
  actualityHeatmapBucketsSortBy,
  actualityHeatmapBucketsSortDirection,
  actualityHeatmapFilters,
  actualityMetricHasStats,
  actualityMetricSelected,
} from '../store/actuality.heatmap.state';

const ActualityHeatmapLegendPanel: React.FC = () => {
  const { t } = useTranslation('feed');
  const formatter = useFormatter();
  const metric = useRecoilValue(actualityMetricSelected);
  const buckets = useRecoilValue(actualityHeatmapBuckets);
  const bucketsWithStats = useRecoilValue(actualityMetricHasStats);
  const metricDescriptorMap = useActualityMetricDescriptors();
  const metricDescriptor = metricDescriptorMap[metric];

  const [sortBy, setSortBy] = useRecoilState(actualityHeatmapBucketsSortBy);
  const [sortDirection, setSortDirection] = useRecoilState(
    actualityHeatmapBucketsSortDirection,
  );
  const showDataTable = useShowFilteredActualityHqTable();
  const [heatmapFilter, setHeatmapFilter] = useRecoilState(
    actualityHeatmapFilters,
  );

  function showFilteredTable(bucket: HeatmapBucket) {
    showDataTable({
      sortValues: {
        [metricDescriptor.path]: SortDirection.DESC,
      },
      searchValues: {
        [metricDescriptor.path]: bucket.id,
      },
    });
  }

  return (
    <HeatmapLegendPanel
      metricDescriptor={metricDescriptor as any}
      buckets={buckets}
      hasStats={bucketsWithStats}
      sortBy={sortBy}
      onSortByChange={v => setSortBy(v)}
      sortDirection={sortDirection}
      onSortDirectionChange={setSortDirection}
      helpNavTo={'actuality/actuality-kpi'}
      heatmapFilter={heatmapFilter}
      onHeatmapFilterChange={v => setHeatmapFilter(v)}
      onBucketActionClick={showFilteredTable}
    />
  );
};

export default ActualityHeatmapLegendPanel;
